module.exports = __webpack_public_path__ + "static/media/code.88ecbdc9.svg";